import { getRequest, postRequest } from "../utils/axios";

export const billingService = {
  getPlans: (onSuccess, onError) => getRequest("/api/v1/plans/", onSuccess, onError),
  checkout: (data, onSuccess, onError) =>
    postRequest("/api/v1/billing/checkout/", data, onSuccess, onError),
  portal: (onSuccess, onError) =>
    postRequest("/api/v1/billing/portal/", {}, onSuccess, onError),
  cancel: (data, onSuccess, onError) =>
    postRequest("/api/v1/billing/cancel/", data || {}, onSuccess, onError),
  changePlan: (data, onSuccess, onError) =>
    postRequest("/api/v1/billing/change-plan/", data, onSuccess, onError),
  listPurchasedSites: (onSuccess, onError) =>
    getRequest("/api/v1/billing/purchased-sites/", onSuccess, onError),
  linkPurchasedSite: (id, projectHash, onSuccess, onError) =>
    postRequest(
      `/api/v1/billing/purchased-sites/${id}/link/`,
      { project: projectHash },
      onSuccess,
      onError,
    ),
};
